module.exports = __webpack_public_path__ + "media/images/front/accArw-d6370295e61d6e20d6c5e140668e8604.png";